import config from '@/types/config';
import { userAgent } from './userAgent';

export const redirectToApp = (accessToken?: string) => {
  const { isFacebook, isInstagram, isAndroid, isIos } = userAgent();

  const appLink = accessToken
    ? `${config.appDeepLinkUrl}?accessToken=${accessToken}`
    : config.appDeepLinkUrl;
  let storeLink = '';

  if (isAndroid) {
    storeLink = config.androidStoreLink;
  } else if (isIos) {
    storeLink = config.iosStoreLink;
  }

  if (isInstagram || isFacebook) {
    window.location.href = storeLink;

    return;
  }

  window.location.href = appLink;

  setTimeout(() => {
    window.location.href = storeLink;
  }, 1500);
};
